<template>
  <v-container>
    <v-form v-model="valid">
      <v-row>
        <v-col cols="12" sm="12">
          <v-text-field
            v-model="name"
            :rules="[rules.min, rules.max]"
            :label="$t('Networks.name')"
            hint="Between 3 and 30 characters"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12">
          <v-textarea v-model="description" auto-grow rows="1">
            <template v-slot:label>
              <div>
                {{$t('Networks.description')}}
                <small>{{$t('Networks.optionnal')}}</small>
              </div>
            </template>
          </v-textarea>
        </v-col>
      </v-row>
    </v-form>
    <save-buttons
      :networkToUpdate="networkToUpdate"
      :networkId="networkId"
      :path="path"
      @back="$emit('backinfo')"
      @error="error"
      @saved="saved"
    ></save-buttons>
  </v-container>
</template>

<script>
import SaveButtonsComponent from "./SaveButtons.vue";

export default {
  components: {
    "save-buttons": SaveButtonsComponent
  },
  props: {
    choosenNetwork: Object,
    path: String
  },
  computed: {
    networkToUpdate: function() {
      let json = {
        valid: this.valid
      };
      if (this.description != "") json.description = this.description;
      if (this.name != "") json.name = this.name;
      return json;
    },
    networkId: function() {
      return this.choosenNetwork.networkId;
    }
  },
  data() {
    return {
      name: "",
      description: "",
      valid: false,
      rules: {
        min: v =>
          v.length >= 3 || v.length == 0 || this.$t("Networks.rules.min"),
        max: v => v.length <= 30 || this.$t("Networks.rules.max")
      }
    };
  },
  methods: {
    error: function(value) {
      this.$emit("error", value);
    },
    saved: function(value) {
      this.$emit("saved", value);
    }
  },
  mounted: function() {
    this.name = this.choosenNetwork.name;
    this.description = this.choosenNetwork.description;
  }
};
</script>